import {inject, Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {KeycloakService} from './keycloak.service';

export const JSON_MIME_TYPE = 'application/json';
export const TEXT_MIME_TYPE = 'text/plain';

/**
 * Shared infrastructure for the direct-booking backend web services.
 *
 * Centralizes the resolved API base url and the construction of authorization
 * headers so the individual web services do not have to duplicate this logic.
 */
@Injectable({
  providedIn: 'root',
})
export class DirectBookingHttpService {
  private readonly keycloakService = inject(KeycloakService);

  public readonly apiBaseUrl = environment.apiUrl + '/api';

  /**
   * Builds the authorization headers for an authenticated backend request.
   *
   * @param contentType Optional `Content-Type` to add to the headers.
   * @returns Headers carrying the current bearer token.
   */
  public authorizationHeaders(contentType?: string): HttpHeaders {
    const token = this.keycloakService.getToken();
    const headers: Record<string, string> = {
      Authorization: `Bearer ${token}`,
    };

    if (contentType) {
      headers['Content-Type'] = contentType;
    }

    return new HttpHeaders(headers);
  }
}
